/**
 * Defines terminal options.
 */
export enum Terminal {
  /**
   * Defines the UK or 'Folkestone' terminal.
   */
  Uk = 'Uk',

  /**
   * Defines the FR or 'Calais' terminal.
   */
  Fr = 'Fr',
}
